// 商品分享
'use client';

import { SHARE_LINK } from '@/common/constant';
import useCopy from '@/hooks/useCopy';

interface Props {
    productName?: string;
}

const ItemShare = ({ productName = '' }: Props) => {
    const copy = useCopy();

    const handleShare = (title: string) => {
        const url = window.location.href;

        if (title === 'copy') {
            copy(url);
            return;
        }

        // 分享文案：快來看！我在SouNova 發現了這個〔商品名〕，我想你也一定有興趣~〔網址〕
        const message = `快來看！我在SouNova 發現了這個『${productName}』，我想你也一定有興趣~\n${url}`;

        // 各平台分享連結，能帶自訂文案的平台就帶上文案，不能的話只帶網址
        const shareUrlMap: Record<string, string> = {
            threads: `https://www.threads.net/intent/post?text=${encodeURIComponent(message)}`,
            line: `https://line.me/R/msg/text/?${encodeURIComponent(message)}`,
            plurk: `https://www.plurk.com/?qualifier=shares&status=${encodeURIComponent(message)}`,
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
            twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`,
        };

        const shareUrl = shareUrlMap[title];
        if (shareUrl) window.open(shareUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="flex items-center gap-x-3 text-black5 text-btn1 px-4 my-5 lg:my-0 lg:px-0">
            Share
            {SHARE_LINK.map(({ title }) => (
                <button
                    key={title}
                    type="button"
                    aria-label={title}
                    onClick={() => handleShare(title)}
                    style={
                        {
                            '--icon-light': `url(/images/share/icon_${title}.svg)`,
                            '--icon-dark': `url(/images/share/icon_dark_${title}.svg)`,
                        } as React.CSSProperties
                    }
                    className={`gtm-item-share-${title} cp trans hover:-translate-y-0.5
                    theme-icon w-8.75 h-8.75 bg-contain bg-center bg-no-repeat`}
                />
            ))}
        </div>
    );
};

export default ItemShare;
